import i18n from '@/i18n'
export const contactMenu = [
  {
    name: 'phone',
    title: i18n.tc('digitalServices.sidebar.callUs'),
    link: 'tel:1600',
    description: i18n.tc('digitalServices.sidebar.callUsNumber'),
    target: '_self'
  },
  {
    name: 'mail',
    title: i18n.tc('digitalServices.sidebar.sendUsEmail'),
    link: 'mailto:korisnicki.servis@mtel.me',
    description: i18n.tc('digitalServices.sidebar.sendUsEmailAddress'),
    target: '_self'
  },
  {
    name: 'site',
    title: i18n.tc('digitalServices.sidebar.visitUs'),
    link: 'https://mtel.me',
    description: i18n.tc('digitalServices.sidebar.visitUsAddress'),
    target: '_blank'
  }
]
